import axios from '@/api/config';

const privacyPolicySetting = {
  addPrivacyPolicySetting(data) {
    return axios.post(`${process.env.BASE_URL}/privacyPolicySetting/addPrivacyPolicySetting`, data);
  },
  updatePrivacyPolicySetting(data) {
    return axios.put(`${process.env.BASE_URL}/privacyPolicySetting/updatePrivacyPolicySetting`, data);
  },
  getPrivacyPolicySetting(data) {
    return axios.get(`${process.env.BASE_URL}/privacyPolicySetting/getPrivacyPolicySetting`, {params:data});
  },
}

export default privacyPolicySetting;



// WEBPACK FOOTER //
// ./src/api/privacyPolicySetting.js